import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import './Navbar.css';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();

    // Close menu when route changes
    useEffect(() => {
        setIsOpen(false);
    }, [location]);

    // Prevent scrolling when menu is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [isOpen]);

    const navItems = [
        { path: '/', label: 'Home' },
        { path: '/blog', label: 'Blog' },
        { path: '/about', label: 'About' },
        { path: '/research', label: 'Research' },
        { path: '/contactus', label: 'Contact' }
    ];

    return (
        <div className="navbar-container">
            <nav className="navbar glass-panel">
                {/* Logo or Brand Name could go here if requested, currently just links */}
                <div className="mobile-logo" style={{ fontWeight: 700, fontSize: '1.2rem', display: 'none' }}>
                    Galilee
                </div>

                {/* Desktop Menu */}
                <ul className="nav-links">
                    {navItems.map((item) => (
                        <li key={item.path}>
                            <Link
                                to={item.path}
                                className={location.pathname === item.path ? 'active' : ''}
                            >
                                {item.label}
                            </Link>
                        </li>
                    ))}
                </ul>

                {/* Mobile Menu Button */}
                <button
                    className="mobile-menu-btn"
                    onClick={() => setIsOpen(!isOpen)}
                    aria-label="Toggle menu"
                >
                    {isOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </nav>

            {/* Mobile Menu Overlay */}
            <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
                <ul>
                    {navItems.map((item) => (
                        <li key={item.path}>
                            <Link to={item.path}>
                                {item.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default Navbar;
